import createReducer from '../../createReducer';
import { startEditing, edit, clear, changeSpecialRequest } from '../actions/EditDishActions';
import { orderItemChangeSpecialRequest } from '../../../utils/DishUtils';
import { clearCustomerSession } from '../actions/SessionActions';

const initialState = {};
const newCustomerState = initialState;

const handlers = {
  [startEditing]: (state, payload) => {
    const { orderItem, cartIndex } = payload;
    return {
      ...state,
      orderItem,
      cartIndex: typeof cartIndex === 'number' ? cartIndex : -1,
    };
  },
  [edit]: (state, payload) => {
    const { orderItem } = payload;
    return {
      ...state,
      orderItem,
    };
  },
  [clear]: () => {
    return initialState;
  },
  [changeSpecialRequest]: (state, payload) => {
    const { specialRequestValue } = payload;
    const { orderItem } = state;
    const updatedItem = orderItemChangeSpecialRequest({ orderItem, specialRequestValue });

    return {
      ...state,
      orderItem: updatedItem,
    };
  },

  [clearCustomerSession]: state => {
    return newCustomerState;
  },
};

export default createReducer(initialState, handlers);
